'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function getScript (url) {
    return new Promise(function (resolve, reject) {
        var tagName = 'script';
        var tag = document.createElement(tagName);
        var firstTag = document.getElementsByTagName(tagName)[0];
        tag.async = true;
        tag.src = url;
        tag.onload = function () { return resolve(); };
        tag.onerror = reject;
        firstTag.parentNode.insertBefore(tag, firstTag);
    });
}

exports.default = getScript;
//# sourceMappingURL=getScript.js.map
